import React from "react";
import './footerAccounts.scss'
export const FooterAccountsPage = () => {
	return (
		<div className="site-footer">
			<footer>
				<div className="payment-info">
					<div className="dx-col">
						<p>
							{" "}
							Payments may take 1-3 days to be reflected.{" "}<br />
							If you don't see the account you are looking for, please contact us at 1-888-978-5371.<br />
		          Our team is available Mon-Fri 8 am to 8:30 pm ET.<br />
		          <span className="lapsed-text">Payments on accounts with lapsed or cancelled policies do not guarantee reinstatement.</span><br/>
		          <span className="lapsed-text">Private Client Select Insurance Services, LLC (“PCS”) d/b/a PC SELECT INSURANCE SERVICES in CA. PCS is a licensed property/casualty insurance producer in all U.S. states and D.C.; CA Surplus Lines License # 6009488</span>
				</p>
					</div>
				</div>
			</footer>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/FooterAccountsPage/FooterAccountsPage.js